/**
@license
Copyright (c) 2023 Advensys LLC. All rights reserved.
*/

import {
  createSlice
} from '@reduxjs/toolkit'

import { createSelector } from 'reselect';
import {dataurl} from '../components/paksh-constants.js'

const initialState = {
  isFetching: false,
  failure: false,
  items: {},
  query : ""
};

export const searchLegalcases = (query) => (dispatch, getState) => {
  // Check to see if the cached results are from the same query.
  // This is useful for avoiding a network request.

  if (shouldSearchLegalcases(getState(), query)) {
    console.log("in Search legal cases")
    dispatch(legalcasesRequested(query));
    let token = window.localStorage.getItem('token');
    // console.log(token)
    if (query) {

      fetch(`${dataurl}/legalcases?q=${query}`, {
        method: 'GET',
        headers: {
          'x-access-token': token,
        }
        })
      .then(res => res.json())
      .then(data => dispatch(legalcasesReceived(query, data.legalcases)))
      .catch(() => dispatch(legalcasesFailed(query)));
      // console.log("fetched data")
    } else {
      // query is empty, clear the results
      // console.log("empty query")
      dispatch(legalcasesReceived(query, []));
    }

  }
};

const shouldSearchLegalcases = (state, query) => {
  console.log("shouldSearchLegalcases")
  // console.log(query)
  console.log(state)
  return state.legalcases.failure || state.legalcases.query !== query && !state.legalcases.isFetching ;
}



export const legalcasesSelector = state => state.legalcases && state.legalcases.items;

export const legalcaseListSelector = createSelector(
  legalcasesSelector,
  (items) => items ? Object.keys(items).map(key => items[key]) : [{},{},{},{},{}]
);

export const legalcasesSlice = createSlice({
  name: 'legalcases',
  initialState,
  reducers: {
    legalcasesRequested(state, action) {
      state.query = null;
      state.items = null; // reset items
      state.failure = false;
      state.isFetching = true;
    },
    legalcasesReceived(state, action) {
      state.items = action.payload.reduce((obj, item) => {
        obj[item.id] = item;
        return obj;
      }, {}),
      state.failure = false;
      state.isFetching = false;
    },
    legalcasesFailed(state, action) {
      console.log("in lwayersFailed -layersSlice")
      state.items= null;
      state.failure = true;
      state.isFetching = false;
    },
    legalcasesUpdated(state, action) {
      state.items = action.payload.reduce((obj, item) => {
        obj[item.id] = item;
        return obj;
      }, {})
    },
  },
})

export const { legalcasesRequested, legalcasesReceived, legalcasesFailed, legalcasesUpdated } = legalcasesSlice.actions

// Export the slice reducer as the default export
export default legalcasesSlice.reducer